import { Switch, useRouteMatch } from 'react-router-dom';

import AuthenticatedPrivateRoute from '../../AuthenticatedPrivateRoute';
import ApplicationGroupingPages from './application-grouping/ApplicationGroupingPages';
import ApplicationPrioritization from './application-prioritization/ApplicationPrioritization';
import MigrationWaves from './migration-waves/MigrationWaves';

function PlanningPages() {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/prioritization`} component={ApplicationPrioritization}/>
            <AuthenticatedPrivateRoute path={`${path}/grouping`} component={ApplicationGroupingPages}/>
            <AuthenticatedPrivateRoute path={`${path}/waves`} component={MigrationWaves}/>
        </Switch>
    );
}

export default PlanningPages;
